'use client';
import React, { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import Head from 'next/head';
import dynamic from 'next/dynamic';

const LandingPage = () => {
    // Dynamically import the ScreenshotCarousel component
    const ScreenshotCarousel = dynamic(() => import('./screenshotcarousel'), { ssr: false, loading: () => <p>Loading...</p> });

    const TestimonialsCarousel = dynamic(() => import('./testimonialscarousel'), { ssr: false, loading: () => <p>Loading...</p> });
    const CardsCarousel = dynamic(() => import('./cardscarousel'), { ssr: false, loading: () => <p>Loading...</p> });

    const router = useRouter();

    // console.log('LandingPage rendered');
    const screenshots = useMemo(
        () => [
            {
                image: 'Screenshot1',
                alt: 'Dashboard View',
                caption: 'Comprehensive dashboard with all key metrics at a glance',
            },
            {
                image: 'Screenshot2',
                alt: 'Analytics View',
                caption: 'Deep dive into your data with powerful analytics tools',
            },
            {
                image: 'Screenshot3',
                alt: 'Team Collaboration',
                caption: 'Seamless team collaboration features built for enterprises',
            },
            {
                image: 'Screenshot4',
                alt: 'Mobile Experience',
                caption: 'Fully responsive design works beautifully on any device',
            },
            {
                image: 'Screenshot5',
                alt: 'Mobile Experience2',
                caption: 'Fully responsive design works beautifully on any device',
            },
            {
                image: 'Screenshot6',
                alt: 'Mobile Experience3',
                caption: 'Fully responsive design works beautifully on any device',
            },
            {
                image: 'Screenshot7',
                alt: 'Mobile Experience4',
                caption: 'Fully responsive design works beautifully on any device',
            },
        ],
        [],
    );

    // Memoize the testimonials array
    const testimonials = useMemo(
        () => [
            {
                name: 'Sarah Johnson',
                position: 'CIO',
                company: 'GlobalTech Inc.',
                photo: 'profile-1',
                quote: 'This platform transformed how we manage our global operations. The implementation was seamless and our team adopted it immediately.',
            },
            {
                name: 'Michael Chen',
                position: 'Director of Operations',
                company: 'OmniCorp',
                photo: 'profile-2',
                quote: "We've reduced operational costs by 30% since implementing this solution. The analytics capabilities alone are worth the investment.",
            },
            {
                name: 'Elena Rodriguez',
                position: 'VP of Product',
                company: 'Innovatech Solutions',
                photo: 'profile-3',
                quote: 'As a fast-growing company, we needed a solution that could scale with us. This platform has exceeded all our expectations.',
            },
        ],
        [],
    );

    const [activeImageIndex, setActiveImageIndex] = useState(0);
    const dashboardImages = [
        '/assets/images/screenshots/Screenshot1.png',
        '/assets/images/screenshots/Screenshot2.png',
        '/assets/images/screenshots/Screenshot3.png',
        '/assets/images/screenshots/Screenshot4.png',
    ];

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setActiveImageIndex((prev) => (prev + 1) % dashboardImages.length);
    //     }, 3000); // Change image every 3 seconds
    //     return () => clearInterval(interval);
    // }, [dashboardImages.length]);

    return (
        <section
            className="relative min-h-screen w-full overflow-auto"
            style={{
                WebkitOverflowScrolling: 'touch', // iOS momentum scrolling
                touchAction: 'pan-y', // Enable vertical scrolling
            }}
        >
            <Head>
                <title>FleetNet | Enterprise Solution</title>
                <meta name="description" content="Powerful enterprise solution for transportation and logistics operations" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                <link rel="icon" href="/assets/images/logo.svg" />
                {/* <meta property="og:image" content="https://fleetnetnew.s3.ap-south-1.amazonaws.com/webassets/screenshots/Screenshot1.png" />
					<meta property="og:title" content="FleetNet | Enterprise Solution" />
					<meta property="og:description" content="Powerful enterprise solution for transportation and logistics operations" /> */}
            </Head>

            {/* Simple sign-in button in top-right corner */}
            <div className="fixed right-4 top-4 z-50">
                <button onClick={() => router.push('/sign-in')} className="rounded-lg bg-white/90 px-4 py-2 font-medium text-blue-600 shadow-sm backdrop-blur-sm transition hover:bg-white">
                    Sign In
                </button>
            </div>

            {/* Hero Section */}
            <section className="relative bg-gradient-to-r from-blue-900 to-indigo-800 px-4 py-20 text-white">
                <div className="mx-auto flex max-w-7xl flex-col items-center md:flex-row">
                    <div className="mb-10 md:mb-0 md:w-1/2">
                        <h1 className="mb-6 text-4xl font-bold leading-tight md:text-5xl">Transform Your Business with Our Platform</h1>
                        <p className="mb-8 text-xl text-blue-100">The all-in-one solution trusted by enterprises worldwide to streamline operations and drive growth.</p>
                        <div className="flex flex-col gap-4 sm:flex-row">
                            <button className="rounded-lg bg-white px-8 py-3 font-semibold text-blue-900 transition duration-300 hover:bg-blue-100" onClick={() => router.push('/sign-up')}>
                                Get Started
                            </button>
                            <button
                                className="rounded-lg border-2 border-white px-8 py-3 font-semibold transition duration-300 hover:bg-white hover:text-blue-900"
                                onClick={() => router.push('/sign-up')}
                            >
                                Request Demo
                            </button>
                        </div>
                    </div>
                    <div className="flex items-center justify-center md:w-1/2">
                        <div className="relative w-full max-w-md">
                            {/* <div className="absolute -inset-4 rotate-2 rounded-2xl bg-blue-700 opacity-20"></div> */}
                            {/* <div className="relative overflow-hidden rounded-xl bg-white shadow-2xl"> */}
                            {/* <Image src="/assets/images/screenshots/Screenshot1.png" alt="Dashboard Preview" className="h-auto w-full" width={600} height={400} layout="responsive" loading="lazy" /> */}
                            {/* <CardsCarousel screenshots={screenshots} /> */}
                            {/* </div> */}
                            <CardsCarousel screenshots={screenshots} />

                            {/* <div className="absolute -inset-4 rotate-2 rounded-2xl bg-blue-700 opacity-20">
									<div className="relative h-[280px] w-[420px]">
										<div className="absolute inset-0 flex items-center justify-center">
											{dashboardImages.map((image, index) => {
												if (index === activeImageIndex) return null; // Skip active image in background

												const zIndex = dashboardImages.length - index - 1;
												const opacity = 0.5;
												const scale = 0.85 - index * 0.05;
												const rotation = index % 2 === 0 ? -8 : 8; // More pronounced angle
												const translateY = index * 8; // Vertical offset for stacking
												const brightness = 70; // Darker background images

												return (
													<div
														key={`bg-${index}`}
														className="absolute overflow-hidden rounded-xl bg-white shadow-xl transition-all duration-700 ease-in-out"
														style={{
															zIndex,
															opacity,
															transform: `scale(${scale}) rotate(${rotation}deg) translateY(${translateY}px)`,
															filter: `brightness(${brightness}%)`,
															width: '90%',
															height: '90%',
														}}
													>
														<Image src={image} alt={`Dashboard Preview ${index + 1}`} className="size-full object-contain" width={600} height={400} loading="lazy" />
													</div>
												);
											})}
										</div>

										<div className="relative z-50 flex size-full items-center justify-center">
											{dashboardImages.map((image, index) => {
												if (index !== activeImageIndex) return null;

												return (
													<div
														key={`active-${index}`}
														className="absolute overflow-hidden rounded-xl bg-white shadow-2xl transition-all duration-700 ease-in-out"
														style={{
															transform: 'scale(1) rotate(0deg)',
															width: '100%',
															height: '100%',
														}}
													>
														<Image src={image} alt={`Dashboard Preview ${index + 1}`} className="size-full object-contain" width={600} height={400} loading="lazy" />
													</div>
												);
											})}
										</div>
									</div>
								</div> */}
                        </div>
                    </div>
                </div>
            </section>

            {/* Auto-scrolling container */}
            <div className="relative overflow-hidden" style={{ touchAction: 'pan-y' }}>
                {/* Gradient fade effects */}
                <div className="absolute left-0 top-0 z-10 h-full w-16 bg-gradient-to-r from-gray-50 to-transparent"></div>
                <div className="absolute right-0 top-0 z-10 h-full w-16 bg-gradient-to-l from-gray-50 to-transparent"></div>

                {/* Scrolling content */}
                <div className="animate-infinite-scroll flex items-center gap-12 whitespace-nowrap">
                    {[...Array(2)].map((_, iteration) => (
                        <React.Fragment key={`iteration-${iteration}`}>
                            {['Company1', 'Company2', 'Company3', 'Company4', 'Company5', 'Company6', 'Company7', 'Company8', 'Company9', 'Company10'].map((company, index) => (
                                <div key={`${company}-${iteration}-${index}`} className="h-18 inline-flex w-48 items-center">
                                    {/* <Image src={`/assets/images/trusted_clients/${company}.png`} alt={company} width={160} height={80} className="h-16 w-full object-contain" quality={100} /> */}
                                    <Image
                                        src={`https://fleetnetnew.s3.ap-south-1.amazonaws.com/webassets/clients/${company}.png`}
                                        alt={company}
                                        width={160}
                                        height={80}
                                        className="size-24 object-contain"
                                        quality={100}
                                    />
                                </div>
                            ))}
                        </React.Fragment>
                    ))}
                </div>
            </div>

            {/* Features Section */}
            <section className="px-4 py-20">
                <div className="mx-auto max-w-7xl">
                    <div className="mb-16 text-center">
                        <h2 className="mb-4 text-3xl font-bold md:text-4xl">Enterprise-Grade Features</h2>
                        <p className="mx-auto max-w-3xl text-xl text-gray-600">Designed to meet the complex needs of modern businesses at scale</p>
                    </div>

                    <div className="grid gap-8 md:grid-cols-3">
                        {features.map((feature, index) => (
                            <div key={index} className="rounded-xl bg-white p-8 shadow-md transition duration-300 hover:shadow-lg">
                                <div className="mb-6 flex size-14 items-center justify-center rounded-lg bg-blue-100">
                                    <feature.icon className="size-6 text-blue-600" />
                                </div>
                                <h3 className="mb-3 text-xl font-semibold">{feature.title}</h3>
                                <p className="text-gray-600">{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Screenshot Carousel with Swiper */}
            <section className="bg-gray-50 px-4 py-20">
                <div className="mx-auto max-w-7xl">
                    <div className="mb-16 text-center">
                        <h2 className="mb-4 text-3xl font-bold md:text-4xl">Explore Our Platform</h2>
                        <p className="mx-auto max-w-3xl text-xl text-gray-600">See how our intuitive interface makes complex tasks simple</p>
                    </div>

                    <div className="relative m-0 mx-auto max-w-5xl p-0">{typeof window !== 'undefined' && <ScreenshotCarousel screenshots={screenshots} />}</div>
                </div>
            </section>

            {/* Testimonials Section with Swiper */}
            <section className="px-4 py-20">
                <div className="mx-auto max-w-7xl">
                    <div className="mb-16 text-center">
                        <h2 className="mb-4 text-3xl font-bold md:text-4xl">What Our Customers Say</h2>
                        <p className="mx-auto max-w-3xl text-xl text-gray-600">Trusted by enterprises across industries</p>
                    </div>

                    <div className="mx-auto max-w-4xl">{typeof window !== 'undefined' && <TestimonialsCarousel testimonials={testimonials} />}</div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="bg-gradient-to-r from-blue-900 to-indigo-800 px-4 py-20 text-white">
                <div className="mx-auto max-w-4xl text-center">
                    <h2 className="mb-6 text-3xl font-bold md:text-4xl">Ready to Transform Your Business?</h2>
                    <p className="mx-auto mb-8 max-w-3xl text-xl text-blue-100">Join thousands of enterprises that trust our platform to power their operations.</p>
                    <div className="flex flex-col justify-center gap-4 sm:flex-row">
                        <button className="rounded-lg bg-white px-8 py-3 font-semibold text-blue-900 transition duration-300 hover:bg-blue-100" onClick={() => router.push('/sign-up')}>
                            Start Free Trial
                        </button>
                        <button
                            className="rounded-lg border-2 border-white px-8 py-3 font-semibold transition duration-300 hover:bg-white hover:text-blue-900"
                            onClick={() => router.push('/pages/contact-us-cover')}
                        >
                            Contact Sales
                        </button>
                    </div>
                </div>
            </section>
        </section>
    );
};

const features = [
    {
        icon: (props: React.SVGProps<SVGSVGElement>) => (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="size-6" {...props}>
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
            </svg>
        ),
        title: 'Robust Reporting',
        description: 'Comprehensive analytics and customizable reports to track all key metrics.',
    },
    {
        icon: (props: React.SVGProps<SVGSVGElement>) => (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="size-6" {...props}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
        ),
        title: 'Enterprise Security',
        description: 'Military-grade encryption and role-based access control for complete data protection.',
    },
    {
        icon: (props: React.SVGProps<SVGSVGElement>) => (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="size-6" {...props}>
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                />
            </svg>
        ),
        title: 'Workflow Automation',
        description: 'Automate repetitive tasks and streamline complex business processes.',
    },
];

export default React.memo(LandingPage);
